'use strict';exports.__esModule = true;var _Constants = require('../../Constants');

var validate = function validate(values, props) {
  var errors = {};

  var limits = {
    publish_limit: props.metaStaff.canAddProperties,
    top_promotion_limit: props.metaStaff.canAddTopPromotions,
    color_promotion_limit: props.metaStaff.canAddColorPromotions };


  if (!values.phone || !values.phone.length) {
    errors.phone = 'emptyField';
  }

  Object.values(_Constants.FIELD_NAMES).forEach(function (field) {
    if (field === _Constants.FIELD_NAMES.PUBLISH_LIMIT && (!values[field] || !values[field].length)) {
      errors[field] = 'emptyField';
    } else if (parseInt(values[field], 10) > limits[field]) {
      errors[field] = 'youHaveExceededLimit';
    }
  });

  return errors;
};exports.default =

validate;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/MyStaffContainer/components/AddNewStaffForm/validate.js
// module id = 2936
// module chunks = 0